module.exports = __webpack_public_path__ + "static/img/fuzhuzhendaun.2650ec0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fuzhuzhendaun.png
// module id = kylY
// module chunks = 1